import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1072ParamStatus: 'idle',
    startProcess1072ParamError: undefined as any,
    loadUserParamsProcess1072ParamStatus: 'idle',
    loadUserParamsProcess1072ParamError: undefined as any,

    process1072ParamList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1072Param = createAsyncThunk('process1072ParamSlice/startProcess1072Param', async ({ process1072Param }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1072Param/`,
        prepareData(process1072Param),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1072ParamStatus } = getState().process1072ParamSlice
        return startProcess1072ParamStatus !== 'pending'
    }
})

export const loadUserParamsProcess1072Param = createAsyncThunk('process1072ParamSlice/loadUserParamsProcess1072Param', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1072Param/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1072ParamStatus } = getState().process1072ParamSlice
        return loadUserParamsProcess1072ParamStatus !== 'pending'
    }
})

const Process1072ParamSlice = createSlice({
    name: 'process1072ParamSlice',
    initialState,
    reducers: {
        resetstartProcess1072Param: (state) => {
            state.job = undefined
            state.startProcess1072ParamError = undefined
        },
        resetstartProcess1072ParamError: (state) => {
            state.startProcess1072ParamError = undefined
        },
        resetloadUserParamsProcess1072Param: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1072ParamError = undefined
        },
        resetloadUserParamsProcess1072ParamError: (state) => {
            state.loadUserParamsProcess1072ParamError = undefined
        },
        removeFromProcess1072ParamListById: (state, action) => {
            state.process1072ParamList = state.process1072ParamList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1072ParamListByIds: (state, action) => {
            state.process1072ParamList = state.process1072ParamList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1072ParamList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1072ParamStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1072ParamList = []
            state.startProcess1072ParamStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1072Param.pending, (state) => {
            state.startProcess1072ParamStatus = 'pending'
            state.startProcess1072ParamError = undefined
        })
        builder.addCase(startProcess1072Param.fulfilled, (state, action) => {
            state.startProcess1072ParamStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1072Param.rejected, (state, action) => {
            state.startProcess1072ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1072ParamError = action.error.message
            } else {
                state.startProcess1072ParamError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1072Param.pending, (state) => {
            state.loadUserParamsProcess1072ParamStatus = 'pending'
            state.loadUserParamsProcess1072ParamError = undefined
        })
        builder.addCase(loadUserParamsProcess1072Param.fulfilled, (state, action) => {
            state.loadUserParamsProcess1072ParamStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1072Param.rejected, (state, action) => {
            state.loadUserParamsProcess1072ParamStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1072ParamError = action.error.message
            } else {
                state.loadUserParamsProcess1072ParamError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1072Param,
    resetstartProcess1072ParamError,
    resetloadUserParamsProcess1072Param,
    resetloadUserParamsProcess1072ParamError,
    removeFromProcess1072ParamListById,
    removeFromProcess1072ParamListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1072ParamSlice.actions
export default Process1072ParamSlice.reducer
